module.exports = __webpack_public_path__ + "media/images/clock-6dbf889ef13fa1f0fc3f0a04a3825fcf.svg";